<template>
  <div class="featured-banners-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${featuredId ? 'Editar' : 'Cadastrar'} Destaque`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'featured-banners.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>

    <app-card>
      <featured-banners-form
        @submit="onSubmit"
        :id="featuredId"
        :errors="errors"
        :saving="isSaving"
      ></featured-banners-form>
    </app-card>
  </div>
</template>

<script>
import FeaturedBannerService from '@/services/featured-banner.service';
import FeaturedBannersForm from '@/components/Forms/FeaturedBannersForm.vue';

export default {
  name: 'featured-banners-form-page',
  components: {
    FeaturedBannersForm,
  },
  data: () => {
    return {
      featuredId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(featured) {
      this.featuredId && this.update(this.featuredId, featured);
      !this.featuredId && this.save(featured);
    },
    save(featured) {
      this.isSaving = true;
      FeaturedBannerService.save(featured)
        .then(() => {
          this.toastify('Destaque cadastrado com sucesso!');
          this.$router.push({ name: 'featured-banners.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Destaque.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, featured) {
      this.isSaving = true;
      FeaturedBannerService.update(id, featured)
        .then(() => {
          this.toastify('Destaque atualizado com sucesso!');
          this.$router.push({ name: 'featured-banners.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Destaque.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.featuredId = this.$route.params.id;
  },
};
</script>
